import React from 'react'
import { FiArrowRightCircle } from "react-icons/fi";
import { ImCancelCircle } from "react-icons/im";
import Swal from 'sweetalert2'

const pricingData = [
  {
    title: "Self Paced Program",
    price: "₹5,999 /-",
    features: [
      { text: "Training Certificate", available: true },
      { text: "Internship Certificate with our Co-Partnered Company", available: true },
      { text: "2 Minor + 2 Major Project", available: true },
      { text: "25+ Hours of video content access", available: true },
      { text: "24+ Hours of mentor live training", available: false },
      { text: "10+ Hours of Live Skill Development Sessions", available: false },
      { text: "Letter Of Recommendation Based on Performance", available: false },
      { text: "Outstanding Certificate for Exceptional Performance in Projects", available: false },
    ],
    link: "https://payments.internselite.net/advance/A6?method=sp"
  },
  {
    title: "Mentor Led Program",
    price: "₹9,999 /-",
    features: [
      { text: "Training Certificate", available: true },
      { text: "Internship Certificate with our Co-Partnered Company", available: true },
      { text: "2 Minor + 2 Major Project", available: true },
      { text: "25+ Hours of video content access", available: true },
      { text: "24+ Hours of mentor live training", available: true },
      { text: "10+ Hours of Live Skill Development Sessions", available: true },
      { text: "Letter Of Recommendation Based on Performance", available: true },
      { text: "Outstanding Certificate for Exceptional Performance in Projects", available: true },
    ],
    link: "https://payments.internselite.net/advance/A6?method=mlp"
  }
];

const handleSubmit = () => {
  Swal.fire({
    icon: 'error',
    title: 'Payment Mood Under Maintenance',
  })
}

function PY_Pricing_card() {
  return (
    <div>
      {/* -----------------Mobile View--------------- */}
      <div className='Curriculum_Containte_box pb-5 d-sm-block d-md-none'>
        <div className='container pt-5'>
          <div className='row'>
            <div className='col-md-12'>
              <div className='text-center Certificates_text'>
                <h2 className='display-6 pb-2'>Python Program Fee</h2>
                <p className=''>Choose from our different pricing plans for our Python.</p>
              </div>
            </div>
          </div>
        </div>
        <div className='container'>
          {pricingData.map((plan, index) => (
            <div className='col-md-12' key={index}>
              <div className='border pricing_card mb-4 shadow bg-white py-3'>
                <div className='px-5'>
                  <h2 className='text-center border-bottom pt-3 py-4'>{plan.title}</h2>
                </div>
                <div className='mobile_view_pricing_card'>
                  <div className='mt-3'>
                    <div className='row px-1'>
                      {plan.features.map((feature, idx) => (
                        <div className='col-12' key={idx}>
                          <div className='row'>
                            <div className='col-2 text-end'>
                              {feature.available ? (
                                <FiArrowRightCircle size="20px" color="#00FF00" />
                              ) : (
                                <ImCancelCircle size="20px" color="red" />
                              )}
                            </div>
                            <div className='col-10'>
                              <p>{feature.text}</p>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
                <div className='py-2'>
                  <div className='pricing_background'>
                    <p className='p-2 px-4 mobile_view_pricing_p'>Fee - {plan.price}</p>
                  </div>
                </div>
                <div className='text-center py-3'>
                  <a href={plan.link}>
                    <button className="shadow-sm mx-4 px-5 pt-2 pb-2 Navbar_button">Buy Now</button>
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* -----------------Desktop View--------------- */}
      <div className='Curriculum_Containte_box pb-5 d-none d-md-block'>
        <div className='container pt-5 pb-4'>
          <div className='row'>
            <div className='col-md-1'></div>
            <div className='col-md-10'>
              <div className='text-center Certificates_text'>
                <h2 className='display-6 pb-2'>Python Program Fee</h2>
                <p className=''>Choose from our different pricing plans for our Python.</p>
              </div>
            </div>
            <div className='col-md-1'></div>
          </div>
        </div>
        <div className='container'>
          <div className='row'>
            <div className='col-md-1'></div>
            {pricingData.map((plan, index) => (
              <div className='col-md-5 px-5' key={index}>
                <div className='border pricing_card shadow bg-white py-3'>
                  <div className='px-5'>
                    <h2 className='text-center border-bottom pt-3 py-4'>{plan.title}</h2>
                  </div>
                  <div className='px-3 mt-4'>
                    <div className='row'>
                      {plan.features.map((feature, idx) => (
                        <div className='col-12' key={idx}>
                          <div className='row'>
                            <div className='col-2 text-end'>
                              {feature.available ? (
                                <FiArrowRightCircle size="20px" color="#00FF00" />
                              ) : (
                                <ImCancelCircle size="20px" color="red" />
                              )}
                            </div>
                            <div className='col-10'>
                              <p>{feature.text}</p>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className='py-2'>
                    <div className='pricing_background'>
                      <p className='px-4 py-2 pricing_background_p'>Fee - {plan.price}</p>
                    </div>
                  </div>
                  <div className='text-center py-3'>
                    <a href={plan.link}>
                      <button className="shadow-sm mx-4 px-5 pt-2 pb-2 Navbar_button">Buy Now</button>
                    </a>
                  </div>
                </div>
              </div>
            ))}
            <div className='col-md-1'></div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PY_Pricing_card
